import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg'
import { useLanguage } from '../../context/LanguageContext';

const ContactPage = () => {
    const { t } = useLanguage();

    return (
        <Fragment>
            <SEO title={t('pages.contact')} />

            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.contact')} pagesub={t('pages.contact')} bgImage={'/banner/iletisim.png'} />
            <Contactpage />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;